(function () {
  const LOG = "[Discount-Code-Price-Adjustment]";

  // ─── Aktiven Code + Prozentsatz auflösen ───────────────────────────────────
  // Server-seitig gerendert von snippets/active-discount-code-data.liquid,
  // gefiltert gegen shop.metafields.custom.displayed_discount_codes (gleiche
  // Erlaubnisliste wie active-discount-banner). cart.discount_applications
  // (Quelle für "code"/"percentage") wird von Shopify aber erst befüllt,
  // sobald der Rabatt gegen mind. eine Cart-Position berechnet werden kann -
  // bei leerem Warenkorb bleibt es leer, auch direkt nach einem
  // /discount/CODE-Link. Fallback für dieses Fenster: die Ajax Cart API
  // (/cart.js) führt den Code trotzdem schon unter discount_codes[] auf (nur
  // ohne Betrag/"applicable"), den % dafür aus der codeMap (Metafield)
  // auflösen. Sobald ein Produkt im Cart liegt, übernimmt die echte,
  // autoritative Cart-Berechnung
  function resolveActiveDiscount() {
    let rawCode = "";
    let percent = 0;
    let codeMap = {};
    try {
      const dataEl = document.getElementById('active-discount-code-data');
      const data = dataEl ? JSON.parse(dataEl.textContent) : null;
      rawCode = (data?.code || "").trim();
      percent = Number(data?.percentage) || 0;
      codeMap = data?.codeMap || {};
    } catch (e) {
      return Promise.resolve(null);
    }

    if (rawCode && percent > 0) return Promise.resolve({ rawCode, percent });
    if (Object.keys(codeMap).length === 0) return Promise.resolve(null);

    return fetch('/cart.js', { headers: { accept: 'application/json' } })
      .then(r => r.json())
      .then(cart => {
        const cartCode = (cart?.discount_codes?.[0]?.code || "").trim().toUpperCase();
        const cartCodePercent = Number(codeMap[cartCode]) || 0;
        if (cartCode && cartCodePercent > 0) {
          return { rawCode: cartCode, percent: cartCodePercent };
        }
        return null;
      })
      .catch(() => null);
  }

  resolveActiveDiscount().then(resolved => {
    if (!resolved) { return; }
    run(resolved.rawCode, resolved.percent);
  });

  function run(rawCode, percent) {
    // Für fake-variant-picker.js: sonst würde die Mengenrabatt-Reconciliation
    // (Rabattcode storniert den Mengen-Tier-Rabatt) erst greifen, wenn bereits
    // etwas im Cart liegt - siehe data-discount-code-active in price.liquid,
    // das genau wie cart.discount_applications erst dann gesetzt ist.
    window.__ntActiveDiscountCode = { code: rawCode, percentage: percent };

    const factor = (100 - percent) / 100;
    const currency = (window.Shopify?.currency?.active || "EUR").toUpperCase();
    const isCHF = currency === "CHF";

    // ─── Parser ────────────────────────────────────────────────────────────
    const parsePrice = (txt) => {
      if (!txt) return null;
      const cleaned = (txt + "").replace(/\s/g, "");
      if (isCHF) {
        // Unterstützt: CHF 1'300.00 / CHF 1,300.00 / CHF 28.99
        const m = cleaned.match(/(?:CHF)?([\d,']+\.?\d{0,2})/);
        if (!m) return null;
        return Number(m[1].replace(/'/g, "").replace(/,/g, ""));
      } else {
        const m = cleaned.match(/(?:€)?\s*([\d\.]+,\d{2}|\d+)/);
        if (!m) return null;
        return Number(m[1].replace(/\./g, "").replace(",", "."));
      }
    };

    const formatPrice = (num) => {
      if (isCHF) {
        const parts = num.toFixed(2).split(".");
        parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, "'");
        return "CHF " + parts.join(".");
      }
      return "€" + num.toFixed(2).replace(".", ",");
    };

    // ─── Auto-Discount-Helfer ──────────────────────────────────────────────
    // Das Theme exponiert den Automatic-Discount-Wert am Preis-Container als
    // data-auto-discount-percentage (z. B. "5"). Der angezeigte DOM-Preis ist
    // bereits um diesen Wert reduziert; die virtual-variants-Daten sind es NICHT.
    const autoPctFromContainer = (container) =>
      container ? (Number(container.dataset.autoDiscountPercentage) || 0) : 0;

    const autoFactorFromPct = (pct) => (100 - pct) / 100;

    // Realer Gesamtrabatt in Prozent (Auto-Discount + Code, multiplikativ) → gerundet
    const comboRealPct = (autoPct) =>
      Math.round((1 - autoFactorFromPct(autoPct) * factor) * 100);

    // Rundet wie Shopifys eigene Rabatt-Allokation: der Rabattbetrag wird in
    // ganzen Cent abgerundet, nicht der Endpreis direkt gerundet (siehe
    // fake-variant-picker-vertical.liquid: "floors price * percentage / 100
    // in integer cents"). Reines n*factor + toFixed(2) kann durch
    // Fließkomma-Ungenauigkeit an Rundungsgrenzen 1 Cent von Shopifys realer
    // Berechnung abweichen (z. B. bei bestimmten Mengen im Warenkorb).
    const applyPercentDiscount = (amount, pct) => {
      const baseCents = Math.round(amount * 100);
      const discountCents = Math.floor((baseCents * pct) / 100);
      return (baseCents - discountCents) / 100;
    };

    // ─── Reset-Hilfsfunktion ───────────────────────────────────────────────
    const resetElement = (el) => {
      if (el.dataset.abOriginal) el.textContent = el.dataset.abOriginal;
      el.removeAttribute('data-ab-discounted');
      el.removeAttribute('data-ab-original');
    };

    // Nur die Marker entfernen, OHNE den alten Text zu restaurieren. Für
    // Elemente, die das Theme selbst neu befüllt (z. B. beim Varianten-/
    // Mengenwechsel) – sonst würde der frische Theme-Preis überschrieben.
    const clearAbMarkers = (nodes) => nodes.forEach(el => {
      el.removeAttribute('data-ab-discounted');
      el.removeAttribute('data-ab-original');
    });

    // ─── DOM-Manipulation ──────────────────────────────────────────────────
    // Gutscheine werden nie durch Rabattcodes rabattiert - markiert über
    // data-gift-card="true" am .price__container (Cards/PDP, siehe price.liquid)
    // bzw. am .cart-item__price-wrapper (Cart, siehe cart-drawer.liquid). Das
    // ATC-Popup hat keine eigene Gutschein-Kennzeichnung und ist davon nicht
    // abgedeckt.
    const isGiftCardPriceEl = (el) => !!el?.closest('[data-gift-card="true"]');

    // Schreibt einen fest vorgegebenen Betrag in den Preistext, ohne den
    // Rest des Textes (Einheit, "/ Stk" o.ä.) anzufassen.
    const setPriceText = (el, newAmount) => {
      if (!el || el.dataset.abDiscounted === "1" || isGiftCardPriceEl(el)) return;
      if (!el.dataset.abOriginal) el.dataset.abOriginal = el.textContent;
      const orig = el.dataset.abOriginal;
      if (isCHF) {
        // Matched CHF + alle gängigen Zahlenformate inkl. Apostroph und Komma als Tausender
        el.textContent = orig.replace(/CHF[\s ]*[\d',.']+/, formatPrice(newAmount));
      } else {
        el.textContent = orig.replace(/(?:€\s*)?([\d\.\,]+)(?!.*[\d\.\,]+)/, formatPrice(newAmount));
      }
      el.dataset.abDiscounted = "1";
    };

    // Liest den aktuell angezeigten Betrag und multipliziert ihn mit dem
    // Code-Faktor. Nur für Preise geeignet, die schon korrekt (ohne
    // stornierten Mengenrabatt) vorreduziert sind - siehe applyVirtualVariantTiles()
    // für die Mengen-Kacheln, wo das NICHT der Fall ist.
    const replaceFirstPriceInText = (el) => {
      if (!el || el.dataset.abDiscounted === "1") return;
      const orig = el.dataset.abOriginal || el.textContent;
      const n = parsePrice(orig);
      if (n == null) return;
      setPriceText(el, applyPercentDiscount(n, percent));
    };

    // ─── Selektoren ────────────────────────────────────────────────────────
    // .price__regular .price-item--regular deckt Produkte OHNE Compare-at-Preis ab
    // (kein Auto-Discount, kein regulärer Vergleichspreis) - price.liquid rendert dann
    // dieses Element statt .price__sale, das sonst komplett ungetroffen bliebe.
    const CARD_PRICE_SEL = [
      '.card-information .price .price__sale .price-item--sale.price-item--last',
      '.card-information .price .price__sale .price-item--regular.show-regular-price',
      '.card-information .price .price__regular .price-item--regular',
      '.card-information .unit-price-item'
    ].join(',');

    const PDP_MAIN_PRICE_SEL = [
      '.product__info-container .price__container-pdp .price__container .price__sale .price-item--sale',
      '.product__info-container .price__container-pdp .price__container .price__sale .price-item--regular.show-regular-price',
      '.product__info-container .price__container-pdp .price__container .price__regular .price-item--regular',
      '.product__info-container .price__reviews--wrapper .price__container .price__sale .price-item--sale',
      '.product__info-container .price__reviews--wrapper .price__container .price__sale .price-item--regular.show-regular-price',
      '.product__info-container .price__reviews--wrapper .price__container .price__regular .price-item--regular'
    ].join(',');

    const PDP_UNIT_PRICE_SEL = [
      '.price__container-pdp .unit-price-item',
      '.product__info-container .unit__price--pdp .unit-price-item'
    ].join(',');

    const ATC_POPUP_PRICE_SEL = [
      '.atc-popup__current-price',
      '.atc-popup__unit-price',
      '.atc-popup__variant-price'
    ].join(',');

    const CART_PRICE_SEL = [
      '.cart-item__discounted-prices .price.price--end[data-lion-price-for-product-id]',
      '.cart-item__discounted-prices .price--end:not(.cart-item__old-price)',
      '.cart-item__old-price.show-regular-price',
      '.cart-item__price', '.cart-item__final-price', '.cart__price'
    ].join(',');

    // Preis-Container, an denen ein Combo-Badge sitzen soll (Karten + PDP-Hauptpreis).
    // Bewusst OHNE [data-auto-discount-percentage]: Produkte ohne Auto-Discount tragen
    // das Attribut gar nicht → autoPctFromContainer() liefert dann 0 (= nur Code-Rabatt).
    const BADGE_HOST_SEL = [
      '.card-information .price__container',
      '.price__container-pdp .price__container'
    ].join(',');

    // ─── Hauptpreis der PDP ────────────────────────────────────────────────
    // Basiert auf dem bereits ANGEZEIGTEN (auto-reduzierten) Preis × Code-Faktor —
    // exakt wie in den Karten. Eine Neuberechnung aus den virtual-variants-Daten
    // wäre falsch: deren Preise sind PRE-Auto-Discount (z. B. €18,99) und lassen
    // sich wegen Shopifys zeilenbasierter Rundung nicht exakt reproduzieren
    // (18,99 × 0,95 = 18,04 → aber angezeigt wird 18,05). Nur der DOM-Preis stimmt.
    // Diese Funktion dient als Sicherheitsnetz; reduceAllPrices() reduziert den
    // Hauptpreis in applyAll() bereits vorher (Guard verhindert Doppelanwendung).
    const applyPdpMainPrice = () => {
      document.querySelectorAll(PDP_MAIN_PRICE_SEL).forEach(el => {
        if (el.dataset.abDiscounted === "1" || isGiftCardPriceEl(el)) return;
        if (!el.dataset.abOriginal) el.dataset.abOriginal = el.textContent;
        const base = parsePrice(el.dataset.abOriginal);
        if (base == null) return;
        el.textContent = formatPrice(applyPercentDiscount(base, percent));
        el.dataset.abDiscounted = "1";
      });
    };

    // ─── Combo-Rabatt-Badges ───────────────────────────────────────────────
    // Ein Badge im Stil des Auto-Discount-Badges, das den realen Gesamtrabatt zeigt.
    // Vorhandenes Badge (Auto-Discount) wird aktualisiert (z. B. -5% → -19%); fehlt
    // eins, wird es neu angelegt (z. B. -15% bei Produkten ohne Auto-Discount).
    //
    // upsert: legt das Badge im übergebenen host an bzw. aktualisiert es.
    const upsertComboBadge = (host, autoPct) => {
      const realPct = comboRealPct(autoPct);
      if (realPct <= 0) return;
      let badge = host.querySelector('.price__badge-auto-discount');
      if (badge) {
        if (!badge.dataset.abOriginal) badge.dataset.abOriginal = badge.textContent;
        badge.textContent = `-${realPct}%`;
        badge.dataset.abDiscounted = "1";
      } else {
        badge = document.createElement('span');
        badge.className = 'badge price__badge-auto-discount color-scheme-4 ab-added-badge';
        badge.textContent = `-${realPct}%`;
        badge.dataset.abDiscounted = "1";
        host.appendChild(badge);
      }
    };

    // Karten + PDP: Auto-Discount-% steckt im data-Attribut des .price__container,
    // das Badge sitzt im umschließenden .price-Wrapper.
    const applyComboBadges = (root = document) => {
      root.querySelectorAll(BADGE_HOST_SEL).forEach(container => {
        if (container.dataset.giftCard === 'true') return;
        const priceWrap = container.closest('.price');
        if (priceWrap) upsertComboBadge(priceWrap, autoPctFromContainer(container));
      });
    };

    // Cart (Drawer + Seite): kein data-auto-discount-percentage vorhanden → den
    // Auto-Wert aus dem bereits gerenderten Badge lesen (sonst 0 = nur Code-Rabatt).
    // Badge sitzt direkt im .cart-item__discounted-prices.
    const applyCartBadges = (root = document) => {
      root.querySelectorAll('.cart-item__discounted-prices').forEach(host => {
        if (isGiftCardPriceEl(host)) return;
        const existing = host.querySelector('.price__badge-auto-discount');
        let autoPct = 0;
        // Nur ECHTE Theme-Badges (Auto-Discount) auslesen. Ein selbst angelegtes
        // Badge (.ab-added-badge) zeigt bereits den Combo-Wert und darf NICHT als
        // Auto-Discount interpretiert werden (sonst stackt sich der Wert bei jedem
        // Lauf auf, z. B. -15% → -28%). Bei bereits aktualisierten Theme-Badges den
        // Ursprungswert aus data-ab-original nehmen.
        if (existing && !existing.classList.contains('ab-added-badge')) {
          const m = (existing.dataset.abOriginal || existing.textContent).match(/(\d+)/);
          autoPct = m ? Number(m[1]) : 0;
        }
        upsertComboBadge(host, autoPct);
      });
    };

    const resetComboBadges = (root = document) => {
      root.querySelectorAll('.price__badge-auto-discount.ab-added-badge').forEach(b => b.remove());
      root.querySelectorAll('.price__badge-auto-discount[data-ab-original]').forEach(resetElement);
    };

    // ─── Preis-pro-Tag-Tooltip (PDP) ───────────────────────────────────────
    // .ac-price-tooltip zeigt "Nur €0,15 / Tag" (= auto-reduzierter Einzelpreis /
    // Tage aus capsules/dosage). Der Wert ist mengen-UNABHÄNGIG (ändert sich beim
    // Varianten-/Mengenwechsel nicht), daher basieren wir direkt auf dem sichtbaren
    // Wert × Code-Faktor. Math.round(...*100)/100 statt toFixed, um Cent-Rundung bei
    // Kleinstbeträgen sauber zu halten. data-price-per-day-text (Pre-Auto, im Theme
    // inkonsistent) wird bewusst ignoriert.
    const PER_DAY_TOOLTIP_SEL = '.ac-price-tooltip';
    const applyPerDayTooltip = () => {
      document.querySelectorAll(PER_DAY_TOOLTIP_SEL).forEach(tip => {
        const span = tip.querySelector('.text');
        if (!span || span.dataset.abDiscounted === "1") return;
        if (!span.dataset.abOriginal) span.dataset.abOriginal = span.textContent;
        const base = parsePrice(span.dataset.abOriginal);
        if (base == null) return;
        const priceStr = formatPrice(applyPercentDiscount(base, percent));
        const tpl = tip.dataset.text;
        span.textContent = (tpl && tpl.includes('__PRICE__'))
          ? tpl.replace('__PRICE__', priceStr)
          : span.dataset.abOriginal.replace(/(?:€\s*)?[\d\.\,]+|CHF[\s ]*[\d',.']+/, priceStr);
        span.dataset.abDiscounted = "1";
      });
    };

    // ─── "Code aktiv"-Banner (Collection + PDP) ────────────────────────────
    // .active-discount-banner rendert immer (siehe active-discount-banner.liquid),
    // aber mit [hidden], solange cart.discount_applications noch nichts liefert
    // (leerer Warenkorb). Hier wird es mit denselben rawCode/percent-Werten wie
    // Preise/Badges befüllt (kein zusätzlicher Request) und eingeblendet - unter
    // Verwendung der im Theme-Editor hinterlegten Text-/Subtext-Vorlagen
    // (data-text-template/data-subtext-template), inkl. [code]/[percentage]
    // Platzhalter. Bereits serverseitig (mit echten Cart-Daten) korrekt
    // gerenderte Banner haben kein [hidden] und werden nicht angefasst.
    const BANNER_SEL = '.active-discount-banner';
    const fillBannerPlaceholders = (tpl) => tpl.replace(/\[code\]/g, rawCode).replace(/\[percentage\]/g, percent);
    const applyDiscountBanners = (root = document) => {
      root.querySelectorAll(BANNER_SEL).forEach(banner => {
        if (!banner.hasAttribute('hidden') || banner.dataset.abDiscounted === "1") return;
        const titleEl = banner.querySelector('.active-discount-banner__title');
        const subtextEl = banner.querySelector('.active-discount-banner__subtext');
        const textTemplate = banner.dataset.textTemplate;
        const subtextTemplate = banner.dataset.subtextTemplate;
        if (titleEl && textTemplate) titleEl.textContent = fillBannerPlaceholders(textTemplate);
        if (subtextEl && subtextTemplate) subtextEl.textContent = fillBannerPlaceholders(subtextTemplate);
        banner.removeAttribute('hidden');
        banner.dataset.abDiscounted = "1";
      });
    };

    // ─── Alle Preise reduzieren ────────────────────────────────────────────
    // Die Mengen-Kacheln (.virtual-variants .variant-current-price) laufen
    // bewusst NICHT hier mit: ihr Text kann bereits einen Mengenrabatt
    // enthalten, der bei aktivem Code eigentlich entfallen müsste (nicht nur
    // ×factor draufmultiplizieren) - siehe applyVirtualVariantTiles().
    const reduceAllPrices = (root = document) => {
      root.querySelectorAll(CARD_PRICE_SEL).forEach(replaceFirstPriceInText);
      root.querySelectorAll(PDP_MAIN_PRICE_SEL).forEach(replaceFirstPriceInText);
      root.querySelectorAll(PDP_UNIT_PRICE_SEL).forEach(replaceFirstPriceInText);
      root.querySelectorAll(ATC_POPUP_PRICE_SEL).forEach(replaceFirstPriceInText);
    };

    // ─── Warenkorb-Preise ──────────────────────────────────────────────────
    // Shopify rechnet Codes je nach Rabattart unterschiedlich in den Cart ein:
    //  - Produktrabatt (z. B. NEUHIER): steckt schon in items[].final_price und
    //    damit im gerenderten Zeilenpreis → NICHT nochmal reduzieren (sonst doppelt).
    //  - Bestellrabatt (z. B. TEST15): steht nur in cart_level_discount_applications,
    //    die Zeilenpreise bleiben voll → hier reduzieren.
    // Ist der Bestellrabatt (noch) nicht anwendbar, z. B. Mindestbestellwert nicht
    // erreicht, fehlt er in cart_level_discount_applications → Preise bleiben voll.
    const applyCartPrices = (root = document) => {
      if (!root.querySelector('.cart-item__discounted-prices')) return;
      fetch('/cart.js', { headers: { accept: 'application/json' } })
        .then(r => r.json())
        .then(cart => {
          const isOrderDiscount = (cart?.cart_level_discount_applications || [])
            .some(app => (app.title || "").trim().toUpperCase() === rawCode.toUpperCase());
          if (isOrderDiscount) root.querySelectorAll(CART_PRICE_SEL).forEach(replaceFirstPriceInText);
        })
        .catch(() => {});
    };

    // ─── Mengen-Kacheln (Kraftreserve-Style Quantity-Selector) ─────────────
    // Nutzt die rohen data-variants-Daten des <virtual-variants>-Elements
    // (Menge + Einzelpreis, quantity-tier-Rabatt) statt den bereits
    // gerenderten Text zu multiplizieren - der kann bei leerem Warenkorb noch
    // den unstornierten Mengenrabatt enthalten (siehe price.liquid /
    // fake-variant-picker.js: Mengenrabatt entfällt komplett bei aktivem
    // Code, es zählt nur noch der Auto-Discount als Basis für den Code).
    // Badges (.variant-discount-badge) zeigen dann nichts mehr Sinnvolles
    // mehr und werden entfernt.
    const applyVirtualVariantTiles = (root = document) => {
      const priceContainerDiv = document.querySelector(
        '.product__info-container .price__container-pdp .price__container'
      );
      const autoDiscountPercentage = parseFloat(priceContainerDiv?.getAttribute('data-auto-discount-percentage') || 0);

      root.querySelectorAll('virtual-variants').forEach(container => {
        let variantData;
        try {
          variantData = JSON.parse(container.getAttribute('data-variants')) || [];
        } catch (e) {
          return;
        }
        if (!variantData.length) return;

        const baseUnitAmount = parsePrice(variantData[0].price);
        if (baseUnitAmount == null) return;
        const baseUnitCents = Math.round(baseUnitAmount * 100);

        variantData.forEach(variant => {
          const tile = container.querySelector(`[data-variant-id="${variant.id}"]`);
          if (!tile || tile.classList.contains('virtual-variant__subscription')) return;
          const priceEl = tile.querySelector('.variant-current-price');
          if (!priceEl || priceEl.dataset.abDiscounted === "1") return;

          // Kachel zeigt den Stückpreis (".../ Stk"), nicht den Zeilen-Gesamtpreis -
          // die Menge fließt hier NICHT ein, sobald der Mengenrabatt storniert ist
          // (alle Kacheln zeigen dann denselben Stückpreis, wie im Einzelstück-Preis).
          const discountPerUnitCents = Math.floor((baseUnitCents * autoDiscountPercentage) / 100);
          const unitAfterAutoCents = baseUnitCents - discountPerUnitCents;
          const finalUnitCents = unitAfterAutoCents - Math.floor((unitAfterAutoCents * percent) / 100);

          setPriceText(priceEl, Math.max(0, finalUnitCents / 100));
          tile.querySelector('.variant-discount-badge')?.remove();
        });
      });
    };

    // ─── ATC Popup ─────────────────────────────────────────────────────────
    const processAtcPopup = popup => {
      if (!popup) return;
      popup.querySelectorAll('[data-ab-discounted]').forEach(resetElement);
      reduceAllPrices(popup);
    };

    (() => {
      const handle = popup => { if (popup) setTimeout(() => processAtcPopup(popup), 150); };
      document.addEventListener('click', e => {
        const btn = e.target.closest('.quick-add__submit');
        if (btn) { handle(btn.closest('.quick-add')?.querySelector('atc-popup-modal')); return; }
        const opener = e.target.closest('modal-opener[data-modal]');
        if (opener) handle(document.querySelector(opener.dataset.modal));
      }, { capture: true });

      const pendingPopups = new Set();
      let rafScheduled = false;
      new MutationObserver(() => {
        document.querySelectorAll('.atc-popup__variant-price:not([data-ab-discounted])').forEach(el => {
          const popup = el.closest('atc-popup-modal');
          if (popup && !pendingPopups.has(popup)) {
            pendingPopups.add(popup);
            if (!rafScheduled) {
              rafScheduled = true;
              requestAnimationFrame(() => {
                rafScheduled = false;
                pendingPopups.forEach(p => handle(p));
                pendingPopups.clear();
              });
            }
          }
        });
      }).observe(document.body, { childList: true, subtree: true });
    })();

    // ─── Apply ─────────────────────────────────────────────────────────────
    const applyAll = (root = document) => {
      reduceAllPrices(root);
      applyCartPrices(root);
      applyPdpMainPrice();
      applyVirtualVariantTiles(root);
      applyComboBadges(root);
      applyCartBadges(root);
      applyPerDayTooltip();
      applyDiscountBanners(root);
    };

    // ─── waitForStablePrice mit Guard ─────────────────────────────────────
    const activeWaiters = new Set();
    function waitForStablePrice(selector, callback, timeout = 2000) {
      if (activeWaiters.has(selector)) return;
      activeWaiters.add(selector);
      const el = document.querySelector(selector);
      if (!el) { activeWaiters.delete(selector); return; }
      let last = el.textContent, stable = 0;
      const interval = setInterval(() => {
        if (el.textContent === last) {
          stable += 100;
          if (stable >= 400) { clearInterval(interval); activeWaiters.delete(selector); callback(el); }
        } else { last = el.textContent; stable = 0; }
      }, 100);
      setTimeout(() => { clearInterval(interval); activeWaiters.delete(selector); }, timeout);
    }

    // ─── Events ────────────────────────────────────────────────────────────
    document.addEventListener('shopify:section:load', () => {
      waitForStablePrice('.price__container-pdp .price-item--last', () => applyAll());
    });
    document.addEventListener('cart-drawer:loaded', () => applyAll());
    document.addEventListener('virtual-variant:change', () => {
      // Das Theme setzt Haupt-, Grundpreis UND den Preis-pro-Tag-Tooltip SYNCHRON
      // neu (das Event feuert erst danach). Deshalb nur deren Marker entfernen –
      // NICHT den alten Wert restaurieren (der alte Preis würde sonst den neuen
      // überschreiben und hängen bleiben). Nach dem Theme-Overwrite steht der
      // frische Wert im DOM, den applyAll() dann neu reduziert. Die Tile-Preise sind
      // statisch und werden nicht angefasst (sonst doppelte Reduktion).
      clearAbMarkers(document.querySelectorAll(
        [PDP_MAIN_PRICE_SEL, PDP_UNIT_PRICE_SEL, PER_DAY_TOOLTIP_SEL + ' .text'].join(',')
      ));
      resetComboBadges();
      applyAll();
    });

    // ─── Init ──────────────────────────────────────────────────────────────
    const isPdp = !!document.querySelector('.product__info-container .price__container-pdp');
    const isBundlePdp = isPdp && !!document.querySelector('.price__container-pdp [data-lion-price-for-product-id]');

    const initApply = () => {
      if (isBundlePdp) {
        waitForStablePrice('.price__container-pdp .price-item--sale', () => applyAll());
      } else {
        applyAll();
      }
    };

    if (document.readyState === 'loading') {
      document.addEventListener("DOMContentLoaded", initApply);
    } else {
      initApply();
    }

    window.addEventListener('pageshow', (e) => {
      if (!e.persisted) return;
      document.querySelectorAll('[data-ab-discounted], [data-ab-original]').forEach(resetElement);
      document.querySelectorAll('.price__badge-auto-discount.ab-added-badge').forEach(b => b.remove());
      initApply();
    });
  }
})();
